import { createAsyncThunk } from '@reduxjs/toolkit'
import { createChatLanguageRoomService, getChatLanguageRoomService, updateChatLanguageRoomStatusService } from 'network/services/chat.service'

export const getChatLanguageRoom = createAsyncThunk(
  'chat/get-language-room',
  async (data, thunkApi) => {
    try {
      const res = await getChatLanguageRoomService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const updateChatLanguageRoomStatus = createAsyncThunk(
  'update/chat-language-room',
  async ({ data, onSuccess, handleDialogClose }, thunkApi) => {
    try {
      const res = await updateChatLanguageRoomStatusService(data)
      onSuccess()
      handleDialogClose()
      return res
    } catch (error) {
      handleDialogClose()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const createChatLanguageRoom = createAsyncThunk(
  'create/chat-language-room',
  async ({ data, onSuccess }, thunkApi) => {
    try {
      const res = await createChatLanguageRoomService(data)
      onSuccess(res.id)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
